import { useNavigate } from "react-router-dom";
import { LogIn, ArrowRight, Tag, Sparkles, Search } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { FoinnLogo } from "../components/FoinnLogo";

export default function SignInLanding() {
  const navigate = useNavigate();
  const { login, openPricing } = useAuth();

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-6 bg-[#f7f3ec] px-6 text-center"
      data-testid="signin-landing"
    >
      <div className="flex items-center gap-3">
        <FoinnLogo className="h-20 w-20" />
        <div className="text-left">
          <h1 className="font-serif text-4xl font-bold leading-none text-[#2d2824]">Foinn.org</h1>
          <p className="text-xs font-bold uppercase tracking-widest text-[#a89e92]">
            Folk Tune Finder
          </p>
        </div>
      </div>

      <p className="max-w-sm text-[#6e655b]">
        Sign in to get <b>20 searches a day</b>, <b>3 free AI Expert analyses</b> and favourites
        synced across your devices.
      </p>

      <div className="flex flex-col items-center gap-3">
        <button
          onClick={login}
          className="flex items-center gap-2 rounded-full bg-[#2d2824] px-8 py-4 text-lg font-extrabold text-white transition-transform hover:scale-105"
          data-testid="landing-signin"
        >
          <LogIn className="h-5 w-5" /> Sign in with Google
        </button>

        <button
          onClick={openPricing}
          className="flex items-center gap-2 rounded-full border-2 border-[#8a2be2] bg-white px-6 py-3 text-sm font-extrabold text-[#8a2be2] transition-transform hover:scale-105"
          data-testid="landing-pricing"
        >
          <Tag className="h-4 w-4" /> See plans & pricing
        </button>

        <div className="mt-2 max-w-xs rounded-2xl border border-[#e5e0d8] bg-white/70 p-4 text-left">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-1.5 text-sm font-extrabold text-[#2d2824] hover:underline"
            data-testid="landing-guest"
          >
            Browse as guest <ArrowRight className="h-4 w-4" />
          </button>
          <ul className="mt-2 space-y-1 text-xs font-semibold text-[#6e655b]">
            <li className="flex items-center gap-1.5">
              <Search className="h-3.5 w-3.5" /> 5 searches a day on this device
            </li>
            <li className="flex items-center gap-1.5">
              <Sparkles className="h-3.5 w-3.5" /> No AI Expert analyses
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
